/**
 * Normalize numeric strings that may use US or EU thousand/decimal conventions.
 * (Keep in sync with src/utils/localizedNumber.ts.)
 */
export function normalizeLocalizedNumberToken(token: string): string {
  const t = String(token || '').trim();
  if (!t) return '';

  const hasComma = t.includes(',');
  const hasDot = t.includes('.');

  if (hasComma && hasDot) {
    const lastComma = t.lastIndexOf(',');
    const lastDot = t.lastIndexOf('.');
    if (lastDot > lastComma) {
      return t.replace(/,/g, '');
    }
    return t.replace(/\./g, '').replace(',', '.');
  }

  if (hasComma && !hasDot) {
    if (/^\d{1,3}(,\d{3})+$/.test(t)) {
      return t.replace(/,/g, '');
    }
    return t.replace(/,/g, '.');
  }

  if (!hasComma && hasDot) {
    if (/^\d{1,3}(\.\d{3}){2,}$/.test(t)) {
      return t.replace(/\./g, '');
    }
    return t;
  }

  return t;
}

export function parseLocalizedNumber(token: string): number {
  const normalized = normalizeLocalizedNumberToken(token);
  if (!normalized) return NaN;
  return parseFloat(normalized);
}
